import { forwardRef, useEffect, useImperativeHandle, useState } from "react"
import { Modal, Box, Button, Stack, Switch, Tooltip } from "@mui/material"
import { useApiService } from "../../hooks/Api/useApiService"
import styles from "../Modals.module.css"
import CaptureVideoImage from "../../hooks/Utils/CaptureVideoImage"
import ModalCloseButton from "../ModalCloseButton"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import T from "../../hooks/Language/T"
import useTranslationSharie from "../../hooks/Language/useTranslation"
import TextField from "../../UI/TextField"
import useError from "../../hooks/Error/useError"
import SkillLevelSelect from "../../UI/SkillLevelSelect"
import { useSocket } from "../../hooks/Utils/Socket/SocketManager"

const NewSkillModal = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    childFunction() {
      handleOpen()
    },
  }))
  const [startDate, setStartDate] = useState(new Date())
  const [open, setOpen] = useState(false)
  const [form_data, setFormData] = useState({})
  const [image, setImage] = useState(null)
  const [update_image, setUpdateImage] = useState(null)
  const [skill_update, setSkillUpdate] = useState({})
  const [is_compressing, setIsCompressing] = useState(false)
  const [date_picker, setDatePicker] = useState(false)
  const { postData } = useApiService()
  const t = useTranslationSharie()
  const guest = localStorage.getItem("guest") === "true"
  const { Error: AlertError, error, success } = useError()
  const socket = useSocket()

  const handleOpen = () => setOpen(true)
  const handleClose = () => {
    localStorage.setItem("new_skill", JSON.stringify({ ...form_data }))
    setOpen(false)
  }

  useEffect(() => {
    const savedSkill = JSON.parse(localStorage.getItem("new_skill"))
    setFormData(savedSkill || {})
    if (props.mode === "update") {
      setSkillUpdate({ ...props.skill })
      setUpdateImage(props.skill.image)
    }
  }, [props.mode, props.skill])
  const handleUpdateSkill = async () => {
    if (skill_update.description.length > 500) {
      error("Description is maximum 500 characters")

      return
    }

    const sentData = {
      ...skill_update,
      start_date: startDate.toLocaleString(),
      user_name: localStorage.getItem("user"),
      image: update_image,
      oldname: props.skill.name,
    }

    if (
      skill_update.name &&
      skill_update.cost &&
      skill_update.location &&
      skill_update.duration &&
      skill_update.description &&
      startDate
    ) {
      postData("skills/updateskill", sentData)
        .then((data) => {
          props.setShouldFetch(true)
          setTimeout(() => {
            props.setShouldFetch(false)
          }, 1000)

          if (data.message === "Failed") {
            error("No Changes Were Made...")
          } else {
            success("Updated Skill Successfully!")
          }
        })
        .catch((error) => {
          error("Image Too Large")
        })
    } else {
      error("You Must Fill All Fields")
    }
  }
  const handlePostSkill = async () => {
    if (
      form_data.name &&
      form_data.cost &&
      form_data.location &&
      form_data.duration &&
      form_data.description &&
      startDate &&
      form_data.level
    ) {
      if (form_data.description.length > 500) {
        error("Description is maximum 500 characters")

        return
      }

      const sentData = {
        ...form_data,
        start_date: startDate.toLocaleString(),
        user_name: localStorage.getItem("user"),
        image: image,
      }

      postData("skills/postskill", sentData)
        .then((data) => {
          if (data.message === "Failed") {
            error("Faild To Send New Skill")
          } else if (data.message === "Skill Already Exists") {
            error(data.message)
          } else {
            sendNotification("post skill")
            success("Skill Has Been Added Successfully!")
            setTimeout(() => {
              setFormData({})
              handleClose()
            }, 3000)
          }
        })
        .catch((error) => {
          error("Image Too Large")
        })
    } else {
      error("You Must Fill All Fields")
    }
  }

  const sendNotification = (type) => {
    try {
      socket?.emit("send_notification", {
        toUserId: props.skill.user_id,
        skill_name: props.skill.name,
        from: localStorage.getItem("user"),
        to: props.skill.user_name,
        type: type,
      })
      postData("sharie/addnotification", {
        skill_name: props.skill.name,
        from: localStorage.getItem("user"),
        type: type,
      }).then((data) => {})
    } catch (error) {
      console.error("Error sending notification:", error)
    }
  }
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-title'
        aria-describedby='modal-description'
      >
        <T>
          <ModalCloseButton handleClose={handleClose} />

          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              width: { xs: "90%", sm: "500px" },
              maxHeight: "90vh",
              overflowY: "auto",
              p: { xs: 2, sm: 4 },
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            {props.mode === "update" ? (
              <Stack spacing={2}>
                <TextField
                  value={skill_update.name}
                  onChange={(e) => setSkillUpdate({ ...skill_update, name: e.target.value })}
                  label={t("Skill Name")}
                  fullWidth
                />
                <TextField
                  value={skill_update.cost}
                  onChange={(e) => setSkillUpdate({ ...skill_update, cost: e.target.value })}
                  label={t("Skill Cost (in credits)")}
                  fullWidth
                />
                <SkillLevelSelect
                  value={form_data?.level}
                  onChange={(e) => setSkillUpdate({ ...skill_update, level: e.target.value })}
                />
                <TextField
                  value={skill_update.location}
                  onChange={(e) => setSkillUpdate({ ...skill_update, location: e.target.value })}
                  label={t("Location")}
                  fullWidth
                />
                {date_picker ? (
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    onSelect={() => setDatePicker(false)}
                    showTimeSelect
                    dateFormat='Pp'
                  />
                ) : (
                  <TextField
                    value={startDate.toLocaleString()}
                    label={t("Start Date")}
                    fullWidth
                    onClick={() => setDatePicker(true)}
                  />
                )}
                <TextField
                  value={skill_update.duration}
                  onChange={(e) => setSkillUpdate({ ...skill_update, duration: e.target.value })}
                  label={t("Duration")}
                  fullWidth
                />

                <TextField
                  label={t("Description")}
                  multiline
                  rows={6}
                  fullWidth
                  value={skill_update.description}
                  onChange={(e) => setSkillUpdate({ ...skill_update, description: e.target.value })}
                />
                <CaptureVideoImage
                  setIsCompressing={setIsCompressing}
                  image={update_image}
                  setImage={setUpdateImage}
                  open={open}
                />
                <Button
                  variant='contained'
                  fullWidth
                  onClick={handleUpdateSkill}
                  disabled={is_compressing || guest}
                >
                  Update Skill
                </Button>
              </Stack>
            ) : (
              <Stack spacing={2}>
                <Tooltip title={form_data.refundable ? t("Refundable") : t("Not Refundable")}>
                  <Switch
                    onChange={(e) => setFormData({ ...form_data, refundable: e.target.checked })}
                  ></Switch>
                </Tooltip>
                <TextField
                  value={form_data?.name || ""}
                  onChange={(e) => setFormData({ ...form_data, name: e.target.value })}
                  label={t("Skill Name")}
                  fullWidth
                />
                <TextField
                  value={form_data?.cost || ""}
                  onChange={(e) => setFormData({ ...form_data, cost: e.target.value })}
                  label={t("Skill Cost (in credits)")}
                  fullWidth
                />
                <SkillLevelSelect
                  value={form_data?.level || ""}
                  onChange={(e) => setFormData({ ...form_data, level: e.target.value })}
                />
                <TextField
                  value={form_data?.location || ""}
                  onChange={(e) => setFormData({ ...form_data, location: e.target.value })}
                  label={t("Location")}
                  fullWidth
                />
                {date_picker ? (
                  <DatePicker
                    value={form_data.start_date?.toLocaleString() || ""}
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    onSelect={() => setDatePicker(false)}
                    showTimeSelect
                    dateFormat='Pp'
                  />
                ) : (
                  <TextField
                    value={startDate.toLocaleString()}
                    label={t("Start Date")}
                    fullWidth
                    onClick={() => setDatePicker(true)}
                  />
                )}
                <TextField
                  value={form_data?.duration || ""}
                  onChange={(e) => setFormData({ ...form_data, duration: e.target.value })}
                  label={t("Duration")}
                  fullWidth
                />
                <TextField
                  value={form_data?.description || ""}
                  label={t("Description")}
                  multiline
                  rows={6}
                  fullWidth
                  onChange={(e) =>
                    setFormData({
                      ...form_data,
                      description: form_data?.description?.length < 251 ? e.target.value : "",
                    })
                  }
                />
                <div
                  style={{
                    marginBottom: "3rem",
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CaptureVideoImage
                    setIsCompressing={setIsCompressing}
                    image={image}
                    setImage={setImage}
                    open={open}
                    upload={props.upload}
                  />
                </div>
                <Button
                  variant='contained'
                  fullWidth
                  onClick={handlePostSkill}
                  disabled={(is_compressing && !image) || guest}
                >
                  Post Skill
                </Button>
              </Stack>
            )}
            <AlertError />
          </Box>
        </T>
      </Modal>
    </div>
  )
})

export default NewSkillModal
